export default "__VITE_ASSET__BfbGu1MF__"